// The free-agent-runs "target" glyph (Figma "Sub Agents icon" / 16-target, node 10849-36265): TWO
// concentric rings (outer + inner, no centre dot), which lucide has no counterpart for — lucide `Target`
// is the three-ring bullseye. Kept as a shared icon component (not inline) per the icons rule; stroke is
// `currentColor` so the call site's Text & Icon/Primary ink applies.
export function SubAgentsTargetIcon({ size = 12, className }: { size?: number; className?: string }) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <circle cx="12" cy="12" r="10" />
      <circle cx="12" cy="12" r="4" />
    </svg>
  );
}
